export enum RecordTypeEnum {
  DEFAULT = 'RECORD_TYPE_UNSPECIFIED',
  ENROLLMENT = 'RECORD_TYPE_ENROLLMENT',
  TEMPLATE = 'RECORD_TYPE_TEMPLATE',
}

// UapFacetPivots represents way to pivot and aggregate data during faceted search.
export interface UapFacetPivots {
  includeMissing: boolean;
  pivotFields: string[];
}

// UapCategoryFacet represents facet search capability against a specific category
export interface UapCategoryFacet {
  fieldName?: string;
  includeMissing?: boolean;
}

// UapRangeFacet represents facet search capability against a specific range.
export interface UapRangeFacet {
  end?: number;
  fieldName?: string;
  gap?: number;
  minCount?: number;
  start?: number;
}

// A list of facets to return counts from the search.
export interface UapFacets {
  categoryFacet?: UapCategoryFacet;
  rangeFacet?: UapRangeFacet;
}

// RangeFilter is a filter that describes two boundary conditions: a start and an end The underlying service and search engine is ultimately responsible for the function of this filter. E.g. the range could be inclusive, exclusive, or start inclusive and end exclusive, etc.
export interface UapRangeFilter {
  dateRange?: {
    start: string;
    end: string;
  };
  doubleRange?: {
    start: number;
    end: number;
  };
  stringRange?: {
    start: string;
    end: string;
  };
  timestampRange?: {
    start: string;
    end: string;
  };
}

// ValueFilter represents a filter that matches against a list of values. The underlying service and search engine is ultimately responsible for the function of this filter. This filter could result in either the union or intersection of the values of the filter.
export interface UapValueFilter {
  doubleValues?: {
    values: number[];
  };
  stringValues?: {
    values: string[];
  };
}

export enum LogicalOperator {
  LOGICAL_OPERATOR_AND = 'LOGICAL_OPERATOR_AND',
  LOGICAL_OPERATOR_OR = 'LOGICAL_OPERATOR_OR',
  LOGICAL_OPERATOR_UNSPECIFIED = 'LOGICAL_OPERATOR_UNSPECIFIED',
}

export enum SortOrder {
  SORT_ORDER_ASCENDING = 'SORT_ORDER_ASCENDING',
  SORT_ORDER_DESCENDING = 'SORT_ORDER_DESCENDING',
  SORT_ORDER_UNSPECIFIED = 'SORT_ORDER_UNSPECIFIED',
}

// A list of sorts to apply to the returned results.
export interface AccountManagementSortGroup {
  fieldName?: string; // The name of the field.
  sortOrder?: SortOrder; // SortOrder describes the sorting order of the result set.
}

// Results of pivoting and grouping.
export interface AccountManagementFacetPivotResult {
  count: number; // Required, total records found under group.
  doubleValue?: number;
  fieldName: string; // Required, field used for grouping.
  missingValue?: boolean;
  pivots: AccountManagementFacetPivotResult[]; // Further pivots within group.
  stringValue?: string;
}

// A list of Facet Pivot Results
export interface AccountManagementFacetPivotResultsGroup {
  result: AccountManagementFacetPivotResult[];
}
